'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var BaseDeviceListView = require('components/devices/views/common/base_device_list_view');
var Utils = require('components/common/utils');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var i18n = require('utils/i18n');
var AppState = require('app_state');
var Consts = require('consts');

module.exports = OOP.extend(
    BaseDeviceListView,
    {
        controller: undefined,
        selectedIdList: undefined,
        enableURLHistory: true,

        initialize: function (options) {
            this.controller = options.controller;
            this.listResult = options.listResult;
            this.itemCount = options.itemCount;
            this.itemsPerPage = options.itemsPerPage;
            this.disablePagination = options.disablePagination;
            this.isSummaryView = options.isSummaryView;
            this.selectedList = options.selectedList;
            this.hasRefreshButton = options.hasRefreshButton;

            this.onSelectionChanged = options.onSelectionChanged;
            this.onRefresh = options.onRefresh;

            AbstractTableView.prototype.initialize.apply(this, [this.getTableConfiguration()]);

            // select models by the id
            if (this.selectedList) {
                var self = this;

                // unselect currently selected (if there are any)
                _.each(this.collection.selected, function (selItem) {
                    selItem.toggleSelected();
                });

                _.each(this.selectedList, function (selItem) {
                    var rowModel = self.collection.get(selItem);
                    if (rowModel) rowModel.toggleSelected();
                });
            } else {
                if (options.defaultSelectAll) this.collection.toggleAllSelectable();
            }

            this.onUpdateGrouping = options.onUpdateGrouping;
            this.triggerSelectionChange();
        },

        refreshTable: function (e) {
            if (this.onRefresh) {
                this.onRefresh();
            }
        },

        getColumnsDialogConfiguration: function () {
            var cfg = this.base.getColumnsDialogConfiguration();
            cfg.category = 'filter';
            cfg.columnCategory = undefined;
            return cfg;
        },

        getTableTitle: function () {
            return this.isSummaryView ? i18n.TR('Geräteauswahl') : i18n.TR('Suchergebnisse ({{itemCount}})');
        },

        updateTableTitle: function () {
            this.$el
                .find('.js-abstract-table-title')
                .text(this.getTableTitle().replace('{{itemCount}}', this.itemCount));
        },

        onRender: function () {
            BaseDeviceListView.prototype.onRender.apply(this, arguments);
            this.updateTableTitle();
        },

        getTableConfiguration: function () {
            var filterColumns = AppState.selectedColumns('filter');
            if (!filterColumns || filterColumns.length == 1) {
                filterColumns = [
                    { id: '#_name', name: 'Name', alwaysVisible: true }, // i18n.TR('Name')
                    { id: '#_category', name: 'Gerätetyp' }, // i18n.TR('Gerät')
                    { id: '#_type', name: 'Type' }, // i18n.TR('Gerätetyp')
                    { id: '#_groups', name: 'Gruppen' }, // i18n.TR('Gruppen')
                    { id: '#_tags', name: 'Tags' }, // i18n.TR('Tags')
                ];
                AppState.setSelectedColumns('filter', filterColumns.slice(1));
            }

            var config = {
                disablePagination: this.disablePagination,
                title: this.getTableTitle(),
                itemCount: this.itemCount,
                currentPage: this.options.currentPage || 1,
                itemsPerPage: this.itemsPerPage,
                listResult: this.listResult,
                getSortColumn: this.getSortColumnFunc(),
                columns: filterColumns,
                hasRefreshButton: this.hasRefreshButton,
                headingID: 'searchresults',
                hasSelectionButtons: true,
                customButtons: [{ ButtonIcon: 'fa fa-cog', ButtonID: 'options' }],
                selectionButtons: this.getSelectionButtons(),
                CSVLink: this.controller && this.controller.getCSVLink ? this.controller.getCSVLink() : undefined,
            };

            return config;
        },

        triggerSelectionChange: function () {
            var self = this;
            setTimeout(function () {
                if (self.onSelectionChanged) {
                    self.onSelectionChanged(self.collection.selected);
                }
            });
        },

        rowSelected: function (e) {
            var result = BaseDeviceListView.prototype.rowSelected.apply(this, [e]);
            this.triggerSelectionChange();
            return result;
        },

        getSelectedList: function () {
            var list = [];
            _.each(this.collection.selected, function (value) {
                list.push(value.get('id'));
            });

            return list;
        },
    },
    'DeviceSelectView'
);
